// Scroll ID for course codes for any purchasing experience.
export const SCROLL_PROGRAM_COURSE = 'course-code';

// Scroll ID for matriculation product on Program/Designation page.
export const SCROLL_PROGRAM_MATRICULATION = 'matriculation';

// Scroll ID for Step ribbon on Program/Designation page.
export const SCROLL_PROGRAM_STEP = 'step';
